/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

"use client";

import { CosmosText } from "@cosmos/components";
import { useTranslation } from "@epic-mw/i18n";
import { useMemo } from "react";

import { VStack } from "@panda/jsx";

import { useGroupedItems } from "../hooks";

import { SearchResultsGroup } from "./SearchResultsGroup.element";

import type { SearchSectionProps } from "./Search.section";

type SearchResultsProps = Pick<SearchSectionProps, "searchResults" | "currentPage">;

export const SearchResults = ({ searchResults, currentPage }: SearchResultsProps): React.JSX.Element => {
	const t = useTranslation();
	const groups = useGroupedItems(searchResults?.items);
	const currentPageGroups = useMemo(() => {
		const start = ((currentPage || 1) - 1) * 5;
		return groups.slice(start, start + 5);
	}, [groups, currentPage]);

	return (
		<VStack
			gap="eds.dimension.40"
			smDown={{ gap: "eds.dimension.32" }}
			paddingBlockStart="eds.dimension.16"
			borderBlockStart="1px solid token(colors.eds.palette.transparent.light.005)"
			width="full"
			alignItems="start"
		>
			<CosmosText variant="uiSM">
				{t(searchResults?.total === 1 ? "epic.cosmos.result" : "epic.cosmos.results", [searchResults?.total || 0])}
			</CosmosText>
			{currentPageGroups?.map((group, i) => (
				<SearchResultsGroup key={`search-results-group-${i}`} {...group} keyProp={`search-results-group-${i}`} />
			))}
		</VStack>
	);
};
